interface ISituacaoMoradia {
  value: string,
  label: string
}

const situacoesDeMoradia: ISituacaoMoradia[] = [
  { value: 'PropriaQuitada', label: 'É um imóvel próprio' },
  { value: 'ConstrucaoNaoConcluida', label: 'É um imóvel próprio com construção não concluída' },
  { value: 'ImovelEmEstadoPrecario', label: 'É um imóvel próprio em estado precário de construção' },
  { value: 'Alugada', label: 'É alugada' },
  { value: 'Coabitada', label: 'É coabitação - duas ou mais famílias conviventes em um mesmo domicílio que possuam a intenção de constituir domicílio exclusivo' },
  { value: 'MoraComOsPais', label: 'É dos meus pais e moro com eles' },
  { value: 'OcupacaoIrregular', label: 'É uma ocupação irregular' },
  { value: 'Cedida', label: 'Foi cedida a mim' },
  { value: 'AluguelSocial', label: 'Aluguel social provisório - Faz parte do programa de aluguel social ou outro programa similar' },
  { value: 'EmSituacaoDeRua', label: 'Situação de rua ou trajetória de rua - utiliza os logradouros públicos como espaço de moradia e de sustento, bem como as unidades de acolhimento institucional para pernoite eventual ou provisório' }
];

export default situacoesDeMoradia;